import { FullscreenExit, Fullscreen } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { useContext } from 'react';

import theme from '../../theme/theme';

import { DisplayMode, SceneCanvasContext } from './SceneCanvasContext';

export const FullScreenToggleButton: React.FC = () => {
  const { displayMode, toggleDisplayMode } = useContext(SceneCanvasContext);
  return (
    <IconButton
      size="small"
      sx={{
        position: displayMode === DisplayMode.FULLSCREEN ? 'fixed' : undefined,
        top: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        background: theme.palette.secondary.main,
        '&:hover': {
          background: theme.palette.secondary.dark,
        },
      }}
      onClick={toggleDisplayMode}
    >
      {displayMode === DisplayMode.FULLSCREEN ? (
        <FullscreenExit sx={{ fill: 'white' }} />
      ) : (
        <Fullscreen sx={{ fill: 'white' }} />
      )}
    </IconButton>
  );
};
